.grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 24px;
}

.card {
  display: flex;
  flex-direction: column;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  /* HACK: card radius from the design; matches the other bold cards on this page. */
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--plume-shadow-card, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
  /* HACK: spring easing from the design; the DS motion tokens have no overshoot curve. */
  transition:
    transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.22s ease;
}

.card:hover {
  transform: var(--plume-hover-shift, translateY(-3px));
  box-shadow: var(--plume-shadow-card-hover, 1px 2px 32px 0 rgba(89, 84, 78, 0.12));
}

.card:focus-visible {
  outline: 3px solid var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
  outline-offset: 3px;
}

/* Holds the frame when a project has no image; the glyph then stands in for the cover. */
.card__cover {
  aspect-ratio: 16 / 10;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  border-bottom: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-sand-500); /* PRIMARY_SAND_500 */
}

.card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card__body {
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}

.card__name {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: 19px; /* HEADING_XS */
  line-height: 1.15;
  letter-spacing: -0.01em;
  text-wrap: pretty;
  /* A project name is arbitrary text, so a word longer than the column has to break somewhere or
     the card's `overflow: hidden` clips it. */
  overflow-wrap: break-word;
}

/* `margin-top: auto` keeps the figures on one line across the row when names wrap unevenly. */
.card__meta {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  font-size: 13px; /* HEADING_5XS */
  font-weight: 600;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
}

.card__meta strong {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: off the DS heading scale, which jumps 22 -> 30 — too coarse for a figure this size. */
  font-size: 28px;
  line-height: 1.05;
  letter-spacing: -0.02em;
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-variant-numeric: tabular-nums;
}

@media (max-width: 1000px) {
  .grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  /* DEVIATION: the design sizes this name at 19px throughout, but two columns at 375px leave the
     card ~120px of text, where "Précommandez" alone overruns the line.
     Hyphenation is scoped here for the same reason: it breaks such a word where French would,
     rather than where `overflow-wrap` would, and at wider columns it would hyphenate names that
     fit perfectly well. `lang="fr"` on the page is what picks the dictionary. */
  .card__name {
    font-size: 17px; /* HEADING_2XS */
    hyphens: auto;
    -webkit-hyphens: auto;
  }
}
